export enum OrderState {
  Active = 1,
  Archived = 2,
}

export const isValidOrderState = (num: number): boolean => {
  return Object.values(OrderState).includes(num);
};
